import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WorkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"work"}/>
}
